export const UNIT_BOSS = "DPM-0013";

export const isTypePheDuyet = (type ,candidateType, candidateId, currentUserId, units, cohorts) => {
    if (type === 'CQ' && units?.find(unit => unit?._id === UNIT_BOSS)?.members?.find(userId => userId === currentUserId) === undefined)
        return true;

    if (type === 'DU' && units?.find(unit => unit?._id === 'DPM-0050')?.members?.find(userId => userId === currentUserId) === undefined)
        return true;

    if (candidateType === 'user' && candidateId === currentUserId)
        return true;

    if (candidateType === 'cohort' && cohorts?.find(cohort => cohort?._id === candidateId && cohort?.members?.find(userId => userId === currentUserId) != undefined) != undefined)
        return true;

    if (candidateType === 'unit' && units?.find(unit => unit?._id === candidateId && unit?.members?.find(userId => userId === currentUserId) != undefined) != undefined)
        return true;
    
    return false;
}

export const getRankUserAtUnit = (user, unitId:String) =>{
    for (const conscription of user.conscriptions) {
      if (unitId == conscription.unitId) return conscription.rank;
    }

    return 1000;
}

export const getAltPrefix = (rank:Number) => {
    if (rank == 100) return "GĐ";
    if (rank == 150) return "PGĐ";
    return "";
}

export const getListBoss = (unit, userList) => {
    let ret = [];

    if (unit.headmaster != "") {
      let headmasterUser = userList.find(user => user?._id === unit?.headmaster)
      ret.push({
        id: headmasterUser.id,
        name: headmasterUser.prefix + " " + headmasterUser.fullname,
        firstname: headmasterUser.firstname,
        gender: headmasterUser.gender,
        status: headmasterUser.status
      });
    }

    for (const head of unit.heads) {
      if (head != unit.headmaster) {
        let headUser = userList.find(user => user?._id === head)
        ret.push({
          id: headUser.id,
          firstname: headUser.firstname,
          name: headUser.prefix + " " + headUser.fullname,
          gender: headUser.gender,
          status: headUser.status
        });
      }
    }

    return ret;
}